"use client";

import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "../cn";

const badgeVariants = cva(
  "inline-flex items-center px-2.5 py-0.5 border rounded-md focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 font-semibold text-xs transition-colors",
  {
    variants: {
      variant: {
        // Match the primary-button contrast (white on saturated primary) so
        // the text stays legible against the filled background.
        default: "border-transparent bg-primary text-white shadow hover:bg-primary/80",
        secondary: "border-transparent bg-secondary text-gray-800 hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive shadow hover:bg-destructive/80",
        outline: "text-600",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
